// src/components/Info.js (Nueva Versión)

import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { donacionSangreData, preparacionCardioData, preparacionQuirurgicaData, preparacionEndoscopiaData } from '../data/hospitalData';
import { Droplet, HeartPulse, ClipboardList, CheckSquare, Stethoscope, MapPin, Clock, Phone } from 'lucide-react';
import '../styles/Info.css';

const TABS = [
  { id: 'donacionSangre', label: 'Donación de Sangre', icon: Droplet },
  { id: 'preparacionEndoscopia', label: 'Prep. VEDA / VCC', icon: Stethoscope },
  { id: 'preparacionPrequirurgica', label: 'Prep. Prequirúrgica', icon: ClipboardList },
  { id: 'estudiosCardio', label: 'Estudios Cardiológicos', icon: HeartPulse },
];

const Info = () => {
    const [activeSection, setActiveSection] = useState('donacionSangre');

    const renderSectionContent = () => {
        switch (activeSection) {
            case 'donacionSangre':
                return (
                    <>
                        <div className="section-header">
                            <Droplet size={40} className="header-icon" />
                            <div>
                                <h1>{donacionSangreData.titulo}</h1>
                                <p>{donacionSangreData.introduccion}</p>
                            </div>
                        </div>
                        <div className="info-layout-split">
                            <div className="info-content-primary">
                                <h3>Requisitos para Donar</h3>
                                <ul className="info-list">
                                    {donacionSangreData.requisitos.map((req, index) => (
                                        <li key={index}><CheckSquare size={18} className="info-list-icon" /> {req}</li>
                                    ))}
                                </ul>
                            </div>
                            <aside className="info-content-secondary">
                                <div className="sidebar-card">
                                    <h4>Datos del Servicio</h4>
                                    <div className="sidebar-info-item"><MapPin size={16} /><div><strong>Ubicación</strong><span>{donacionSangreData.ubicacion.direccion}</span></div></div>
                                    <div className="sidebar-info-item"><Clock size={16} /><div><strong>Horarios</strong><span>{donacionSangreData.ubicacion.horarios}</span></div></div>
                                    
                                </div>
                            </aside>
                        </div>
                    </>
                );
            case 'preparacionEndoscopia':
                 return (
                    <>
                        <div className="section-header">
                            <Stethoscope size={40} className="header-icon" />
                            <div>
                                <h1>{preparacionEndoscopiaData.titulo}</h1>
                                <p>{preparacionEndoscopiaData.introduccion}</p>
                            </div>
                        </div>
                        <div className="info-layout-full">
                             <div className="info-subsection">
                                <h3>{preparacionEndoscopiaData.veda.titulo}</h3>
                                <ul className="info-list">
                                    {preparacionEndoscopiaData.veda.puntos.map((punto, index) => (
                                        <li key={index}><CheckSquare size={18} className="info-list-icon" /> {punto}</li>
                                    ))}
                                </ul>
                            </div>
                             <div className="info-subsection">
                                <h3>{preparacionEndoscopiaData.vcc.titulo}</h3>
                                <ul className="info-list">
                                    {preparacionEndoscopiaData.vcc.puntos.map((punto, index) => (
                                        <li key={index}><CheckSquare size={18} className="info-list-icon" /> {punto}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </>
                );
            case 'preparacionPrequirurgica':
                return (
                    <>
                        <div className="section-header">
                            <ClipboardList size={40} className="header-icon" />
                            <div>
                                <h1>{preparacionQuirurgicaData.titulo}</h1>
                                <p>{preparacionQuirurgicaData.introduccion}</p>
                            </div>
                        </div>
                        <div className="info-layout-full">
                            <h3>{preparacionQuirurgicaData.preparacionGeneral.titulo}</h3>
                            <ul className="info-list">
                                {preparacionQuirurgicaData.preparacionGeneral.puntos.map((punto, index) => (
                                    <li key={index}><CheckSquare size={18} className="info-list-icon" /> {punto}</li>
                                ))}
                            </ul>
                        </div>
                    </>
                );
            case 'estudiosCardio':
                return (
                    <>
                        <div className="section-header">
                            <HeartPulse size={40} className="header-icon" />
                            <div>
                                <h1>Preparación para Estudios Cardiovasculares</h1>
                                <p>Encontrá las instrucciones específicas para prepararte para tu estudio cardiológico.</p>
                            </div>
                        </div>
                        <div className="info-layout-cards">
                            {preparacionCardioData.map(estudio => (
                                <div key={estudio.id} className="estudio-card">
                                    <h4>{estudio.titulo}</h4>
                                    <p>{estudio.descripcion}</p>
                                    <ul>
                                        {estudio.instrucciones.map((inst, index) => <li key={index}>{inst}</li>)}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </>
                );
            default: return null;
        }
    };

    return (
        <div className="info-page-wrapper">
            <div className="info-container">
                <nav className="info-tabs-nav">
                    {TABS.map((tab) => {
                        const Icon = tab.icon;
                        return (
                            <button 
                                key={tab.id}
                                className={`info-tab-button ${activeSection === tab.id ? 'active' : ''}`}
                                onClick={() => setActiveSection(tab.id)}
                            >
                                <Icon size={20} />
                                <span>{tab.label}</span>
                            </button>
                        );
                    })}
                </nav>

                <main className="info-content-card">
                     <AnimatePresence mode="wait">
                        <motion.div
                            key={activeSection}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                        >
                            {renderSectionContent()}
                        </motion.div>
                    </AnimatePresence>
                </main>
            </div>
        </div>
    );
};

export default Info;